/* eslint-disable sort-keys */
export const urls: Record<
  'es-en',
  Record<string, '/l/es/en' | `/l/es/en/${string}`>
> = {
  'es-en': {
    // Home
    '': '/l/es/en/home',

    // Alumni
    alumni: '/l/es/en/alumni',

    // B2B
    enterprise: '/l/es/en/b2b',
    'enterprise/contact': '/l/es/en/b2b/apply',

    // Campus
    barcelona: '/l/es/en/campus/bcn',
    madrid: '/l/es/en/campus/mad',
    remote: '/l/es/en/campus/rmt',

    // Career
    career: '/l/es/en/career',

    // Courses
    'web-development': '/l/es/en/course/wd',
    'data-analytics': '/l/es/en/course/da',
    'ux-ui-design': '/l/es/en/course/ux',
    cybersecurity: '/l/es/en/course/cy',

    // FAQ
    faq: '/l/es/en/faq',

    // Financing Options
    'financing-options': '/l/es/en/financing',

    // Forms
    apply: '/l/es/en/apply',
    apply2: '/l/es/en/full-apply',
    contact: '/l/es/en/contact',
    'financing-form': '/l/es/en/financing-form',
    'thank-you': '/l/es/en/thank-you',

    // Quiz
    quiz: '/l/es/en/quiz',
    'artificial-intelligence/match': '/l/es/en/quiz-match/ai',
    'cybersecurity/match': '/l/es/en/quiz-match/cy',
    'data-analytics/match': '/l/es/en/quiz-match/da',
    'devops-cloud-computing/match': '/l/es/en/quiz-match/dv',
    'digital-marketing/match': '/l/es/en/quiz-match/mk',
    'data-science-machine-learning/match': '/l/es/en/quiz-match/ml',
    'ux-ui-design/match': '/l/es/en/quiz-match/ux',
    'web-development/match': '/l/es/en/quiz-match/wd',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/es/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/es/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/es/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/es/en/syllabus/cy',
    'data-analytics/syllabus': '/l/es/en/syllabus/da',
    'data-engineering/syllabus': '/l/es/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/es/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/es/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/es/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/es/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/es/en/syllabus/ux',
    'web-development/syllabus': '/l/es/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/es/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/es/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/es/en/pdp/ce/rmt',
    'cybersecurity/barcelona': '/l/es/en/pdp/cy/bcn',
    'cybersecurity/madrid': '/l/es/en/pdp/cy/mad',
    'cybersecurity/remote': '/l/es/en/pdp/cy/rmt',
    'data-analytics/barcelona': '/l/es/en/pdp/da/bcn',
    'data-analytics/madrid': '/l/es/en/pdp/da/mad',
    'data-analytics/remote': '/l/es/en/pdp/da/rmt',
    'data-engineering/remote': '/l/es/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/es/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/es/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/es/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/es/en/pdp/pm/rmt',
    'ux-ui-design/barcelona': '/l/es/en/pdp/ux/bcn',
    'ux-ui-design/madrid': '/l/es/en/pdp/ux/mad',
    'ux-ui-design/remote': '/l/es/en/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
